export enum RegionStorageKey {
  LANGUAGE = 'locale',
  REGION = 'region',
}

export enum Region {
  EE = 'EE',
  UK = 'UK',
  US = 'US',
  ES = 'ES',
  IE = 'IE',
  DE = 'DE',
  FR = 'FR',
  CA = 'CA',
  AU = 'AU',
  ZA = 'ZA',
}
